module.exports = __webpack_public_path__ + "img/left_top_bg.6ea76d3f.png";